/**
 * @author James Adams
 */
function SoldierState(id){
  this.createPageState(id,{
    "type":"Standard",
    "name":"",
    "move":6,
    "fight":2,
    "shoot":2,
    "armor":10,
    "will":0,
    "health":12,
    "cost":0,
    "notes":"Pistol, Light Armour, Knife",

    "gearSlots": 1,
    "gear":[],

    "addRoster":null,
    "errorMessage":"",

    editSoldier: null,
    createSoldier:null,
    cancelCreate:null
  });
}

export default SoldierState;
